import { useTheme } from '@emotion/react';
import { Box, Button, Typography, Divider } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSessionState } from '../../utils/hooks/global/useSessionStorage';
import { useState } from 'react';

import { mockDataUser } from '../../data/mockData';
import DebugMode from './DebugMode';
import SignifyAuth from './SignifyAuth';

export const login = async () => {
  return mockDataUser;
};

const Login = () => {
  const location = useLocation();
  const theme = useTheme();
  const debug = process.env.REACT_APP_DEBUG;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [storedUrl, setStoredUrl] = useSessionState(location.pathname, 'url');
  const [authMode, setAuthMode] = useState('choose');

  const google = () => {
    setStoredUrl(location.pathname);
    window.open(`${backendUrl}/auth/google/login`, '_self');
  };

  const renderAuthChoice = () => (
    <Box
      mt={'30px'}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
    >
      <Button
        onClick={() => setAuthMode('signify')}
        variant="outlined"
        color={theme.palette.mode === 'dark' ? 'secondary' : 'primary'}
        size="large"
        sx={{
          minWidth: 200,
          px: 2,
        }}
      >
        Login with Veridian
        <img
          src="https://github.com/cardano-foundation/veridian-wallet/blob/main/src/assets/icon-only.png?raw=true"
          alt="Veridian logo"
          style={{ height: 30, marginLeft: 12 }}
        />
      </Button>

      <Divider sx={{ width: '100%', my: 2 }}>
        <Typography variant="body2" color="text.secondary">
          OR
        </Typography>
      </Divider>

      <Button
        onClick={() => {
          setStoredUrl(location.pathname);
          google();
        }}
        variant="outlined"
        color={theme.palette.mode === 'dark' ? 'secondary' : 'primary'}
        size="large"
        sx={{
          minWidth: 200,
          px: 2,
        }}
      >
        Login with Google
        <img
          src="https://img.icons8.com/color/512/google-logo.png"
          alt="Veridian logo"
          style={{ height: 30, marginLeft: 12 }}
        />
      </Button>
    </Box>
  );

  const renderContent = () => {
    if (debug === 'true') {
      return <DebugMode />;
    }

    switch (authMode) {
      case 'signify':
        return (
          <Box>
            <Box textAlign="center" mb={2}>
              <Button
                onClick={() => setAuthMode('choose')}
                variant="text"
                size="medium"
                sx={{ marginTop: '50px' }}
              >
                ← Back to login options
              </Button>
            </Box>
            <SignifyAuth />
          </Box>
        );
      case 'choose':
      default:
        return renderAuthChoice();
    }
  };

  return (
    <>
      <Box>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'column'}
        >
          <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <img
              src={`${process.env.PUBLIC_URL}/images/chalmuns-cantina-logo-cropped.png`}
              alt="Chalmuns Cantina"
              style={{ width: '300px', height: '300px' }}
            />
          </Box>
          {renderContent()}
        </Box>
      </Box>
    </>
  );
};

export default Login;
